<template name="home">
    <div class="home-container">
        <img src="@/assets/images/home/homeBg.png" alt="">
    </div>
</template>

<script>
export default {
  
};
</script>



<style lang="scss" scoped>
.home-container {
    width: 100%;
    height: 100%;
    background-color: #f0f0f0;
    img {
        width: 100%;
        height: 100%;
    }
}
</style>